import React, { useState } from 'react';
import ImageCropperModal from './ImageCropperModal';

const ExtraDetails = ({ extraDetails, setExtraDetails, isMobileCategory, isUiUxCategory, isStartupCategory, isCustomCategory, isMultipleCategory, extraImages, setExtraImages, architectingImages, setArchitectingImages, isSubmitted }) => {
  const [cropImageSrc, setCropImageSrc] = useState(null);
  const [cropIndex, setCropIndex] = useState(null);

  const updateField = (field, value) => {
    setExtraDetails(prev => ({ ...prev, [field]: value }));
  };

  const VAL = {
    UIUX: { kcTitle: 20, kcDesc: 100, solTitle: 40, solDesc: 250, solPoints: 60, aiTitle: 30, aiDesc: 260, aiStats: 25, impLabel: 30, impValue: 10 },
    MOBILE: { kcTitle: 55, kcDesc: 155, isTitle: 40, isDesc: 250, isPoints: 60, aiTitle: 30, aiDesc: 260, aiStats: 30, impDesc: 140, impLabel: 30, impValue: 10 },
    CUSTOM: { chDescMin: 150, chDescMax: 220, solDescMin: 150, solDescMax: 220, aiTitle: 5, aiMaxTitle: 70, aiMaxStats: 35 },
    STARTUP: {
      advHeadingMax: 37,
      advTitleMax: 37,
      advDescMax: 75,
      csTitleMax: 60,
      csDescMin: 230,
      csDescMax: 350,
      aiTitleMax: 33,
      aiDescMin: 80,
      aiDescMax: 115
    }
  };

  const getValidationError = (condition, msg) => {
    if (condition) return <div className="text-danger small mt-1">{msg}</div>;
    return null;
  };

  const updateArrayField = (field, index, key, value) => {
    setExtraDetails(prev => {
      const arr = [...(prev[field] || [])];
      if (!arr[index]) {
        arr[index] = {};
      }
      arr[index][key] = value;
      return { ...prev, [field]: arr };
    });
  };

  const updateStringArrayField = (field, index, value) => {
    setExtraDetails(prev => {
      const arr = [...(prev[field] || [])];
      arr[index] = value;
      return { ...prev, [field]: arr };
    });
  };

  const updateArrayFieldPoints = (field, index, pointIndex, value) => {
    setExtraDetails(prev => {
      const arr = [...(prev[field] || [])];
      if (!arr[index]) {
        arr[index] = { points: [] };
      }
      const points = [...(arr[index].points || ['', ''])];
      points[pointIndex] = value;
      arr[index].points = points;
      return { ...prev, [field]: arr };
    });
  };

  const addArrayItem = (field, defaultObj) => {
    setExtraDetails(prev => ({
      ...prev,
      [field]: [...(prev[field] || []), defaultObj]
    }));
  };

  const removeArrayItem = (field, index) => {
    setExtraDetails(prev => ({
      ...prev,
      [field]: (prev[field] || []).filter((_, i) => i !== index)
    }));
  };

  const updateImpact = (key, value) => {
    setExtraDetails(prev => ({
      ...prev,
      measurableImpact: { ...(prev.measurableImpact || {}), [key]: value }
    }));
  };

  const updateCustomKeyResult = (key, value) => {
    setExtraDetails(prev => ({
      ...prev,
      customKeyResults: { ...(prev.customKeyResults || {}), [key]: value }
    }));
  };

  const addCustomAiPoint = () => {
    setExtraDetails(prev => {
      const arr = [...(prev.customAiAdvantages || [])];
      const newArr = arr.map(adv => ({
        ...adv,
        points: [...(adv.points || []), '']
      }));
      return { ...prev, customAiAdvantages: newArr };
    });
  };

  const removeCustomAiPoint = () => {
    setExtraDetails(prev => {
      const arr = [...(prev.customAiAdvantages || [])];
      const pointsLength = arr[0]?.points?.length || 0;
      if (pointsLength <= 1) return prev;

      const newArr = arr.map(adv => ({
        ...adv,
        points: (adv.points || []).slice(0, -1)
      }));
      return { ...prev, customAiAdvantages: newArr };
    });
  };

  const addMobileChallengeSolution = () => {
    setExtraDetails(prev => {
      const kc = [...(prev.keyChallenges || [])];
      const is = [...(prev.intelligentSolutions || [])];
      if (kc.length >= 3) return prev;
      return {
        ...prev,
        keyChallenges: [...kc, { title: '', description: '' }],
        intelligentSolutions: [...is, { title: '', description: '' }]
      };
    });
  };

  const removeMobileChallengeSolution = () => {
    setExtraDetails(prev => {
      const kc = [...(prev.keyChallenges || [])];
      const is = [...(prev.intelligentSolutions || [])];
      if (kc.length <= 1) return prev;
      return {
        ...prev,
        keyChallenges: kc.slice(0, -1),
        intelligentSolutions: is.slice(0, -1)
      };
    });
  };

  const addCustomChallengeSolution = () => {
    setExtraDetails(prev => {
      const cc = prev.customChallenges || ['', ''];
      const cs = prev.customSolutions || ['', ''];
      return {
        ...prev,
        customChallenges: [...cc, ''],
        customSolutions: [...cs, '']
      };
    });
  };

  const removeCustomChallengeSolution = () => {
    setExtraDetails(prev => {
      const cc = prev.customChallenges || ['', ''];
      const cs = prev.customSolutions || ['', ''];
      if (cc.length <= 2) return prev;
      return {
        ...prev,
        customChallenges: cc.slice(0, -1),
        customSolutions: cs.slice(0, -1)
      };
    });
  };

  const handleExtraImageChange = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      setExtraImages(prev => {
        const newArr = [...(prev || [])];
        newArr[index] = file;
        return newArr;
      });
    }
  };

  const removeExtraImage = (index) => {
    setExtraImages(prev => (prev || []).filter((_, i) => i !== index));
  };

  const onSelectArchitectingFile = (e, index) => {
    if (e.target.files && e.target.files.length > 0) {
      setCropIndex(index);
      const reader = new FileReader();
      reader.addEventListener('load', () => setCropImageSrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      e.target.value = null; // reset input
    }
  };

  const handleCropComplete = (croppedFile) => {
    setArchitectingImages(prev => {
      const newArr = [...(prev || [])];
      newArr[cropIndex] = croppedFile;
      return newArr;
    });
    setCropImageSrc(null);
    setCropIndex(null);
  };

  const removeArchitectingImage = (index) => {
    setArchitectingImages(prev => {
      const newArr = [...(prev || [])];
      newArr[index] = null;
      return newArr;
    });
  };

  const showMultipleFields = isMultipleCategory;
  const showMobileFields = isMobileCategory && !isUiUxCategory && !isStartupCategory && !isCustomCategory && !showMultipleFields;
  const showUiUxFields = isUiUxCategory && !showMultipleFields;
  const showStartupFields = isStartupCategory && !showMultipleFields;
  const showCustomFields = isCustomCategory && !showMultipleFields;
  const isAiEnabled = extraDetails?.enableAiAdvantage === true || extraDetails?.enableAiAdvantage === 'true';
  const isImpactEnabled = extraDetails?.enableMeasurableImpact === true || extraDetails?.enableMeasurableImpact === 'true';

  if (!showMobileFields && !showUiUxFields && !showStartupFields && !showCustomFields && !showMultipleFields) {
    return (
      <div className="mt-4 mb-4">

        <div className="card-body">
          <div className="row">
            <div className="col-sm-6 mb-3">
              <label className="form-label">Timeline</label>
              <input type="text" className="form-control" placeholder="Enter timeline" value={extraDetails?.timeline || ''} onChange={(e) => updateField('timeline', e.target.value)} />
            </div>
            <div className="col-sm-6 mb-3">
              <label className="form-label">Technologies (comma separated)</label>
              <input type="text" className="form-control" placeholder="React, Node.js, etc." value={extraDetails?.technologies || ''} onChange={(e) => updateField('technologies', e.target.value)} />
            </div>
          </div>
        </div>
      </div>
    );
  }


  return (
    <div className="mt-4 mb-4">
      <div className="">
        <div className="row">
          <div className="col-sm-4 mb-4">
            <label className="form-label">Timeline</label>
            <input type="text" className="form-control" placeholder="Enter timeline" value={extraDetails?.timeline || ''} onChange={(e) => updateField('timeline', e.target.value)} required />
          </div>
          {/* <div className="col-sm-6 mb-3">
            <label className="form-label">Technologies (comma separated)</label>
            <input type="text" className="form-control" placeholder="React, Node.js, etc." value={extraDetails?.technologies || ''} onChange={(e) => updateField('technologies', e.target.value)} />
          </div> */}

          {(showMobileFields || showMultipleFields) && (
            <div className="col-sm-4 mb-4">
              <label className="form-label">Architecture</label>
              <input type="text" className="form-control" placeholder="Enter architecture" value={extraDetails?.architecture || ''} onChange={(e) => updateField('architecture', e.target.value)} required />
            </div>
          )}

          <div className="col-sm-4 mb-4">
            <label className="form-label">Industry</label>
            <input type="text" className="form-control" placeholder="Enter industry" value={extraDetails?.industry || ''} onChange={(e) => updateField('industry', e.target.value)} required />
          </div>



          <div className="col-sm-4 mb-4">
            <label className="form-label">Platforms</label>
            <input type="text" className="form-control" placeholder="Enter platforms" value={extraDetails?.platforms || ''} onChange={(e) => updateField('platforms', e.target.value)} required />
          </div>

        </div>
      </div>

      <div className="card-body p-0">

        {showMultipleFields && (
          <div className="mb-4">
            <label className="form-label font-weight-bold">Technologies</label>
            <div className="row">
              <div className="col-sm-4 mb-3">
                <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Web Technologies</label>
                <input type="text" className="form-control" placeholder="React, Tailwind" value={extraDetails?.technologies?.web || ''} onChange={(e) => updateField('technologies', { ...extraDetails?.technologies, web: e.target.value })} required />
              </div>
              <div className="col-sm-4 mb-3">
                <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Mobile Technologies</label>
                <input type="text" className="form-control" placeholder="Swift, Kotlin" value={extraDetails?.technologies?.mobile || ''} onChange={(e) => updateField('technologies', { ...extraDetails?.technologies, mobile: e.target.value })} required />
              </div>
              <div className="col-sm-4 mb-3">
                <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>UI/UX Technologies</label>
                <input type="text" className="form-control" placeholder="Figma, Protopie" value={extraDetails?.technologies?.uiux || ''} onChange={(e) => updateField('technologies', { ...extraDetails?.technologies, uiux: e.target.value })} required />
              </div>
            </div>
          </div>
        )}

        {(showMobileFields || showUiUxFields || showMultipleFields) && (
          <div className="mb-4">
            <label className="form-label font-weight-bold">Key Challenges</label>
            <div className="row">
              {Array.from({ length: showMultipleFields ? 3 : (showUiUxFields ? 2 : Math.min(3, Math.max(1, extraDetails?.keyChallenges?.length || 1))) }).map((_, i) => {
                const item = (extraDetails?.keyChallenges || [])[i] || {};
                return (
                  <div className={showMultipleFields ? "col-sm-4 mb-3" : "col-sm-6 mb-3"} key={`kc-${i}`}>
                    <div className="border p-3 rounded h-100">
                      <div className="mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Title</label>
                        <input type="text" className="form-control" placeholder="Title" value={item.title || ''} maxLength={showMobileFields || showMultipleFields ? VAL.MOBILE.kcTitle : (showUiUxFields ? VAL.UIUX.kcTitle : undefined)} onChange={(e) => updateArrayField('keyChallenges', i, 'title', e.target.value)} />
                        {getValidationError(isSubmitted && (!item.title || item.title.trim() === ''), 'Title is required')}
                      </div>
                      <div className="mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Description</label>
                        <textarea className="form-control" placeholder="Description" rows="5" value={item.description || ''} maxLength={showMobileFields || showMultipleFields ? VAL.MOBILE.kcDesc : (showUiUxFields ? VAL.UIUX.kcDesc : undefined)} onChange={(e) => updateArrayField('keyChallenges', i, 'description', e.target.value)} />
                        {getValidationError(isSubmitted && (!item.description || item.description.trim() === ''), 'Description is required')}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {showMobileFields && (
              <div className="mt-2">
                {/* <button type="button" className="btn btn-primary btn-sm me-2" onClick={addMobileChallengeSolution} disabled={(extraDetails?.keyChallenges?.length || 0) >= 3}>+ Add Challenge & Solution</button>
                {(extraDetails?.keyChallenges?.length > 1) && (
                  <button type="button" className="btn btn-danger btn-sm" onClick={removeMobileChallengeSolution}>- Remove Last Pair</button>
                )} */}
              </div>
            )}
          </div>
        )}

        {showUiUxFields && (
          <div className="mb-4">
            <label className="form-label font-weight-bold">Architecting the Solution</label>
            <div className="row">
              {Array.from({ length: 2 }).map((_, i) => {
                const item = (extraDetails?.architectingSolution || [])[i] || {};
                return (
                  <div className="col-sm-6 mb-3" key={`arch-${i}`}>
                    <div className="border p-3 rounded h-100">
                      <div className="mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Title</label>
                        <input type="text" className="form-control" placeholder="Title" value={item.title || ''} maxLength={VAL.UIUX.solTitle} onChange={(e) => updateArrayField('architectingSolution', i, 'title', e.target.value)} />
                      </div>
                      <div className="mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Image (546x350)</label>
                        <input type="file" accept="image/*" className="form-control form-control-sm" onChange={(e) => onSelectArchitectingFile(e, i)} />
                        {architectingImages && architectingImages[i] && (
                          <div className="mt-2 position-relative" style={{ width: 'fit-content' }}>
                            <img
                              src={typeof architectingImages[i] === 'string' ? architectingImages[i] : URL.createObjectURL(architectingImages[i])}
                              alt={`Cropped ${i}`}
                              style={{ width: '100%', maxWidth: '150px', borderRadius: '4px', border: '1px solid #ddd' }}
                            />
                            <button
                              type="button"
                              className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1 p-0"
                              style={{ width: '20px', height: '20px', lineHeight: '18px' }}
                              onClick={() => removeArchitectingImage(i)}
                            >
                              &times;
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Description</label>
                        <textarea className="form-control" placeholder="Description" rows="8" value={item.description || ''} maxLength={VAL.UIUX.solDesc} onChange={(e) => updateArrayField('architectingSolution', i, 'description', e.target.value)} />
                      </div>
                      <div className="row">
                        <div className="col-sm-6 mb-2">
                          <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Point 1 (Optional)</label>
                          <input type="text" className="form-control" placeholder="Point 1 (Optional)" value={(item.points || [])[0] || ''} maxLength={VAL.UIUX.solPoints} onChange={(e) => updateArrayFieldPoints('architectingSolution', i, 0, e.target.value)} />
                        </div>
                        <div className="col-sm-6 mb-2">
                          <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Point 2 (Optional)</label>
                          <input type="text" className="form-control" placeholder="Point 2 (Optional)" value={(item.points || [])[1] || ''} maxLength={VAL.UIUX.solPoints} onChange={(e) => updateArrayFieldPoints('architectingSolution', i, 1, e.target.value)} />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {(showMobileFields || showMultipleFields) && (
          <div className="mb-4">
            <label className="form-label font-weight-bold">Intelligent Solutions</label>
            <div className="row">
              {Array.from({ length: showMultipleFields ? 3 : Math.min(3, Math.max(1, extraDetails?.intelligentSolutions?.length || 1)) }).map((_, i) => {
                const item = (extraDetails?.intelligentSolutions || [])[i] || {};
                return (
                  <div className={showMultipleFields ? "col-sm-4 mb-3" : "col-sm-6 mb-3"} key={`is-${i}`}>
                    <div className="border p-3 rounded h-100">
                      <div className="mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Title</label>
                        <input type="text" className="form-control" placeholder="Title" value={item.title || ''} maxLength={VAL.MOBILE.isTitle} onChange={(e) => updateArrayField('intelligentSolutions', i, 'title', e.target.value)} />
                        {getValidationError(isSubmitted && (!item.title || item.title.trim() === ''), 'Title is required')}
                      </div>
                      <div className="mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Description</label>
                        <textarea className="form-control" placeholder="Description" rows="5" value={item.description || ''} maxLength={VAL.MOBILE.isDesc} onChange={(e) => updateArrayField('intelligentSolutions', i, 'description', e.target.value)} />
                        {getValidationError(isSubmitted && (!item.description || item.description.trim() === ''), 'Description is required')}
                      </div>
                      {/* <div className="row">
                      <div className="col-sm-6 mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Point 1 (Optional)</label>
                        <input type="text" className="form-control" placeholder="Point 1 (Optional)" value={(item.points || [])[0] || ''} maxLength={VAL.MOBILE.isPoints} onChange={(e) => updateArrayFieldPoints('intelligentSolutions', i, 0, e.target.value)} />
                      </div>
                      <div className="col-sm-6 mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Point 2 (Optional)</label>
                        <input type="text" className="form-control" placeholder="Point 2 (Optional)" value={(item.points || [])[1] || ''} maxLength={VAL.MOBILE.isPoints} onChange={(e) => updateArrayFieldPoints('intelligentSolutions', i, 1, e.target.value)} />
                      </div>
                    </div> */}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {(showMobileFields || showUiUxFields) && (
          <div className="mb-4">
            <div className="form-check form-switch mb-3 d-flex align-items-center" style={{ paddingLeft: 0 }}>
              <input className="form-check-input m-0" type="checkbox" role="switch" id="enableMobileAi" checked={isAiEnabled} onChange={(e) => updateField('enableAiAdvantage', e.target.checked)} style={{ cursor: 'pointer' }} />
              <label className="form-check-label font-weight-bold mb-0" htmlFor="enableMobileAi" style={{ fontSize: '1rem', cursor: 'pointer', marginLeft: '0.75rem' }}>Include AI-Driven Advantage?</label>
            </div>
            {isAiEnabled && (
              <div className="row">
                {Array.from({ length: showMultipleFields ? 3 : Math.min(3, Math.max(1, extraDetails?.aiAdvantages?.length || 1)) }).map((_, i) => {
                  const item = (extraDetails?.aiAdvantages || [])[i] || {};
                  return (
                    <div className="col-sm-4 mb-3" key={`ai-${i}`}>
                      <div className="border p-3 rounded h-100">
                        <div className="mb-2">
                          <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Title</label>
                          <input type="text" className="form-control" placeholder="Title" value={item.title || ''} maxLength={isUiUxCategory ? VAL.UIUX.aiTitle : VAL.MOBILE.aiTitle} onChange={(e) => updateArrayField('aiAdvantages', i, 'title', e.target.value)} />
                        </div>
                        <div className="mb-2">
                          <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Description</label>
                          <textarea className="form-control" placeholder="Description" rows="10" value={item.description || ''} maxLength={isUiUxCategory ? VAL.UIUX.aiDesc : VAL.MOBILE.aiDesc} onChange={(e) => updateArrayField('aiAdvantages', i, 'description', e.target.value)} />
                        </div>
                        <div className="mb-2">
                          <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Stats</label>
                          <input type="text" className="form-control" placeholder="Stats" value={item.stats || ''} maxLength={isUiUxCategory ? VAL.UIUX.aiStats : VAL.MOBILE.aiStats} onChange={(e) => updateArrayField('aiAdvantages', i, 'stats', e.target.value)} />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {showStartupFields && (
          <>
            <div className="mb-4">
              <label className="form-label font-weight-bold">Advantage</label>
              <div className="row">
                {(extraDetails?.startupAdvantages || []).slice(0, 3).map((item, i) => (
                  <div className="col-sm-4 mb-3" key={`sa-${i}`}>
                    <div className="border p-3 rounded h-100">
                      <div className="mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Heading</label>
                        <input type="text" className="form-control" placeholder="Heading" value={item.heading || ''} maxLength={VAL.STARTUP.advHeadingMax} onChange={(e) => updateArrayField('startupAdvantages', i, 'heading', e.target.value)} />
                      </div>
                      <div className="mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Title</label>
                        <input type="text" className="form-control" placeholder="Title" value={item.title || ''} maxLength={VAL.STARTUP.advTitleMax} onChange={(e) => updateArrayField('startupAdvantages', i, 'title', e.target.value)} />
                      </div>
                      <div className="mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Description</label>
                        <textarea className="form-control" placeholder="Description" rows="2" value={item.description || ''} maxLength={VAL.STARTUP.advDescMax} onChange={(e) => updateArrayField('startupAdvantages', i, 'description', e.target.value)} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-sm-6">
                <label className="form-label font-weight-bold">The Challenge</label>
                {(extraDetails?.startupChallenges || []).slice(0, 1).map((item, i) => (
                  <div className="mb-3" key={`sc-${i}`}>
                    <div className="border p-3 rounded h-100">
                      <div className="mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Title</label>
                        <input type="text" className="form-control" placeholder="Title" value={item.title || ''} maxLength={VAL.STARTUP.csTitleMax} onChange={(e) => updateArrayField('startupChallenges', i, 'title', e.target.value)} />
                      </div>
                      <div className="mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Description</label>
                        <textarea className="form-control" placeholder="Description" rows="2" value={item.description || ''} maxLength={VAL.STARTUP.csDescMax} onChange={(e) => updateArrayField('startupChallenges', i, 'description', e.target.value)} />
                        {getValidationError((item.description?.length || 0) > 0 && (item.description?.length || 0) < VAL.STARTUP.csDescMin, `Description must be at least ${VAL.STARTUP.csDescMin} characters`)}
                      </div>
                      <div className="mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Stats</label>
                        <input type="text" className="form-control" placeholder="Stats" value={item.stats || ''} onChange={(e) => updateArrayField('startupChallenges', i, 'stats', e.target.value)} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="col-sm-6">
                <label className="form-label font-weight-bold">The Solution</label>
                {(extraDetails?.startupSolutions || []).slice(0, 1).map((item, i) => (
                  <div className="mb-3" key={`ss-${i}`}>
                    <div className="border p-3 rounded h-100">
                      <div className="mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Title</label>
                        <input type="text" className="form-control" placeholder="Title" value={item.title || ''} maxLength={VAL.STARTUP.csTitleMax} onChange={(e) => updateArrayField('startupSolutions', i, 'title', e.target.value)} />
                      </div>
                      <div className="mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Description</label>
                        <textarea className="form-control" placeholder="Description" rows="2" value={item.description || ''} maxLength={VAL.STARTUP.csDescMax} onChange={(e) => updateArrayField('startupSolutions', i, 'description', e.target.value)} />
                        {getValidationError((item.description?.length || 0) > 0 && (item.description?.length || 0) < VAL.STARTUP.csDescMin, `Description must be at least ${VAL.STARTUP.csDescMin} characters`)}
                      </div>
                      <div className="mb-2">
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Stats</label>
                        <input type="text" className="form-control" placeholder="Stats" value={item.stats || ''} onChange={(e) => updateArrayField('startupSolutions', i, 'stats', e.target.value)} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-4">
              <div className="form-check form-switch mb-3 d-flex align-items-center" style={{ paddingLeft: 0 }}>
                <input className="form-check-input m-0" type="checkbox" role="switch" id="enableStartupAi" checked={isAiEnabled} onChange={(e) => updateField('enableAiAdvantage', e.target.checked)} style={{ cursor: 'pointer' }} />
                <label className="form-check-label font-weight-bold mb-0" htmlFor="enableStartupAi" style={{ fontSize: '1rem', cursor: 'pointer', marginLeft: '0.75rem' }}>Include AI-Driven Advantage?</label>
              </div>

              {isAiEnabled && (
                <div className="row">
                  {(extraDetails?.startupAiAdvantages || []).slice(0, 3).map((item, i) => (
                    <div className="col-sm-4 mb-3" key={`sai-${i}`}>
                      <div className="border p-3 rounded h-100">
                        <div className="mb-2">
                          <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Title</label>
                          <input type="text" className="form-control" placeholder="Title" value={item.title || ''} maxLength={VAL.STARTUP.aiTitleMax} onChange={(e) => updateArrayField('startupAiAdvantages', i, 'title', e.target.value)} />
                        </div>
                        <div className="mb-2">
                          <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Description</label>
                          <textarea className="form-control" placeholder="Description" rows="5" value={item.description || ''} maxLength={VAL.STARTUP.aiDescMax} onChange={(e) => updateArrayField('startupAiAdvantages', i, 'description', e.target.value)} />
                          {getValidationError((item.description?.length || 0) > 0 && (item.description?.length || 0) < VAL.STARTUP.aiDescMin, `Description must be at least ${VAL.STARTUP.aiDescMin} characters`)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </>
        )}

        {showCustomFields && (
          <>
            <div className="mb-4">
              <label className="form-label font-weight-bold">Key Results</label>
              <div className="row mb-2">
                <div className="col-sm-4 mb-3">
                  <div className="border p-3 rounded h-100">
                    <div className="mb-2">
                      <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Percentage</label>
                      <input type="text" className="form-control" placeholder="Percentage" value={extraDetails?.customKeyResults?.percentage || ''} onChange={(e) => updateCustomKeyResult('percentage', e.target.value)} />
                    </div>
                    <div className="mb-2">
                      <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Percentage Description</label>
                      <input type="text" className="form-control" placeholder="Percentage Description" value={extraDetails?.customKeyResults?.percentageDesc || ''} onChange={(e) => updateCustomKeyResult('percentageDesc', e.target.value)} />
                    </div>
                  </div>
                </div>
                <div className="col-sm-4 mb-3">
                  <div className="border p-3 rounded h-100">
                    <div className="mb-2">
                      <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Downtime</label>
                      <input type="text" className="form-control" placeholder="Downtime" value={extraDetails?.customKeyResults?.downtime || ''} onChange={(e) => updateCustomKeyResult('downtime', e.target.value)} />
                    </div>
                    <div className="mb-2">
                      <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Downtime Description</label>
                      <input type="text" className="form-control" placeholder="Downtime Description" value={extraDetails?.customKeyResults?.downtimeDesc || ''} onChange={(e) => updateCustomKeyResult('downtimeDesc', e.target.value)} />
                    </div>
                  </div>
                </div>
                <div className="col-sm-4 mb-3">
                  <div className="border p-3 rounded h-100">
                    <div className="mb-2">
                      <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Historical data</label>
                      <input type="text" className="form-control" placeholder="Historical data" value={extraDetails?.customKeyResults?.historical || ''} onChange={(e) => updateCustomKeyResult('historical', e.target.value)} />
                    </div>
                    <div className="mb-2">
                      <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Historical data Description</label>
                      <input type="text" className="form-control" placeholder="Historical data Description" value={extraDetails?.customKeyResults?.historicalDesc || ''} onChange={(e) => updateCustomKeyResult('historicalDesc', e.target.value)} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-4">
              <div className="row">
                <div className="col-sm-6 mb-3">
                  <div className="border p-3 rounded h-100">
                    <label className="form-label font-weight-bold mb-3">The Challenges</label>
                    {(extraDetails?.customChallenges || ['', '']).map((desc, i) => (
                      <div className="mb-3" key={`cc-${i}`}>
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Challenge {i + 1}</label>
                        <textarea className="form-control" placeholder={`Challenge Description ${i + 1}`} rows="4" value={desc || ''} maxLength={VAL.CUSTOM.chDescMax} onChange={(e) => updateStringArrayField('customChallenges', i, e.target.value)} />
                        {getValidationError((desc?.length || 0) > 0 && (desc?.length || 0) < VAL.CUSTOM.chDescMin, `Minimum ${VAL.CUSTOM.chDescMin} characters required`)}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-sm-6 mb-3">
                  <div className="border p-3 rounded h-100">
                    <label className="form-label font-weight-bold mb-3">Our Solutions</label>
                    {(extraDetails?.customSolutions || ['', '']).map((desc, i) => (
                      <div className="mb-3" key={`cs-${i}`}>
                        <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Solution {i + 1}</label>
                        <textarea className="form-control" placeholder={`Solution Description ${i + 1}`} rows="4" value={desc || ''} maxLength={VAL.CUSTOM.solDescMax} onChange={(e) => updateStringArrayField('customSolutions', i, e.target.value)} />
                        {getValidationError((desc?.length || 0) > 0 && (desc?.length || 0) < VAL.CUSTOM.solDescMin, `Minimum ${VAL.CUSTOM.solDescMin} characters required`)}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* <div className="mt-2">
                <button type="button" className="btn btn-primary btn-sm me-2" onClick={addCustomChallengeSolution}>+ Add Challenge & Solution</button>
                {((extraDetails?.customChallenges || ['', '']).length > 2) && (
                  <button type="button" className="btn btn-danger btn-sm" onClick={removeCustomChallengeSolution}>- Remove Last Pair</button>
                )}
              </div> */}
            </div>
          </>
        )}

        {(showCustomFields || showMultipleFields) && (
          <div className="mb-4">
            <div className="form-check form-switch mb-3 d-flex align-items-center" style={{ paddingLeft: 0 }}>
              <input className="form-check-input m-0" type="checkbox" role="switch" id="enableCustomAi" checked={isAiEnabled} onChange={(e) => updateField('enableAiAdvantage', e.target.checked)} style={{ cursor: 'pointer' }} />
              <label className="form-check-label font-weight-bold mb-0" htmlFor="enableCustomAi" style={{ fontSize: '1rem', cursor: 'pointer', marginLeft: '0.75rem' }}>Include AI-Driven Advantage?</label>
            </div>

            {isAiEnabled && (
              <div>
                <div className="row">
                  {Array.from({ length: showMultipleFields ? 3 : Math.min(3, Math.max(1, extraDetails?.customAiAdvantages?.length || 1)) }).map((_, i) => {
                    const item = (extraDetails?.customAiAdvantages || [])[i] || {};
                    return (
                      <div className="col-sm-4 mb-3" key={`cai-${i}`}>
                        <div className="border p-3 rounded h-100">
                          <div className="mb-2">
                            <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Title</label>
                            <input type="text" className="form-control" placeholder={`Advantage Title ${i + 1}`} value={item.title || ''} maxLength={VAL.CUSTOM.aiMaxTitle} onChange={(e) => updateArrayField('customAiAdvantages', i, 'title', e.target.value)} />
                            {getValidationError((item.title?.length || 0) > 0 && (item.title?.length || 0) < VAL.CUSTOM.aiTitle, `Minimum ${VAL.CUSTOM.aiTitle} characters required`)}
                          </div>
                          <div className="mb-2">
                            <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Stats</label>
                            <input type="text" className="form-control" placeholder="Stats" value={item.stats || ''} maxLength={VAL.CUSTOM.aiMaxStats} onChange={(e) => updateArrayField('customAiAdvantages', i, 'stats', e.target.value)} />
                          </div>
                          <div className="mb-2">
                            <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Points</label>
                            <div className="row">
                              {(item.points || []).map((pt, pIdx) => (
                                <div className="col-sm-12 mb-2" key={`pt-${pIdx}`}>
                                  <input type="text" className="form-control form-control-sm" placeholder={`Point ${pIdx + 1}`} value={pt || ''} onChange={(e) => updateArrayFieldPoints('customAiAdvantages', i, pIdx, e.target.value)} />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="mb-3">
                  <button type="button" className="btn btn-primary btn-sm me-2" onClick={addCustomAiPoint}>+ Add Point</button>
                  {(extraDetails?.customAiAdvantages?.[0]?.points?.length > 1) && (
                    <button type="button" className="btn btn-danger btn-sm" onClick={removeCustomAiPoint}>- Remove Point</button>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {(showMobileFields || showUiUxFields) && (
          <div className="mb-4">
            <div className="form-check form-switch mb-3 d-flex align-items-center" style={{ paddingLeft: 0 }}>
              <input className="form-check-input m-0" type="checkbox" role="switch" id="enableMeasurableImpact" checked={isImpactEnabled} onChange={(e) => updateField('enableMeasurableImpact', e.target.checked)} style={{ cursor: 'pointer' }} />
              <label className="form-check-label font-weight-bold mb-0" htmlFor="enableMeasurableImpact" style={{ fontSize: '1rem', cursor: 'pointer', marginLeft: '0.75rem' }}>Include Measurable Impact?</label>
            </div>
            {isImpactEnabled && (
              <>
                <label className="form-label font-weight-bold">Measurable Impact Details</label>
                <div className="row">
                  {showMobileFields && (
                    <div className="col-sm-12 mb-2">
                      <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Description</label>
                      <textarea className="form-control" placeholder="Description" rows="2" value={extraDetails?.measurableImpact?.description || ''} maxLength={VAL.MOBILE.impDesc} onChange={(e) => updateImpact('description', e.target.value)} />
                    </div>
                  )}

                  {showMobileFields && (
                    <>
                      <div className="col-sm-6 mb-3">
                        <div className="border p-3 rounded h-100">
                          <div className="mb-2">
                            <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Label</label>
                            <input type="text" className="form-control" placeholder="Label" value={extraDetails?.measurableImpact?.userSatisfactionLabel || ''} maxLength={VAL.MOBILE.impLabel} onChange={(e) => updateImpact('userSatisfactionLabel', e.target.value)} />
                          </div>
                          <div className="mb-2">
                            <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Value</label>
                            <input type="text" className="form-control" placeholder="Value" value={extraDetails?.measurableImpact?.userSatisfaction || ''} maxLength={VAL.MOBILE.impValue} onChange={(e) => updateImpact('userSatisfaction', e.target.value)} />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 mb-3">
                        <div className="border p-3 rounded h-100">
                          <div className="mb-2">
                            <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Label</label>
                            <input type="text" className="form-control" placeholder="Label" value={extraDetails?.measurableImpact?.activeDownloadsLabel || ''} maxLength={VAL.MOBILE.impLabel} onChange={(e) => updateImpact('activeDownloadsLabel', e.target.value)} />
                          </div>
                          <div className="mb-2">
                            <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Value</label>
                            <input type="text" className="form-control" placeholder="Value" value={extraDetails?.measurableImpact?.activeDownloads || ''} maxLength={VAL.MOBILE.impValue} onChange={(e) => updateImpact('activeDownloads', e.target.value)} />
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {showUiUxFields && (
                    <>
                      <div className="col-sm-4 mb-3">
                        <div className="border p-3 rounded h-100">
                          <div className="mb-2">
                            <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Label</label>
                            <input type="text" className="form-control" placeholder="Label" value={extraDetails?.measurableImpact?.increaseInConversionLabel || ''} maxLength={VAL.UIUX.impLabel} onChange={(e) => updateImpact('increaseInConversionLabel', e.target.value)} />
                          </div>
                          <div className="mb-2">
                            <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Value</label>
                            <input type="text" className="form-control" placeholder="Value" value={extraDetails?.measurableImpact?.increaseInConversion || ''} maxLength={VAL.UIUX.impValue} onChange={(e) => updateImpact('increaseInConversion', e.target.value)} />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-4 mb-3">
                        <div className="border p-3 rounded h-100">
                          <div className="mb-2">
                            <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Label</label>
                            <input type="text" className="form-control" placeholder="Label" value={extraDetails?.measurableImpact?.reductionInBounceRateLabel || ''} maxLength={VAL.UIUX.impLabel} onChange={(e) => updateImpact('reductionInBounceRateLabel', e.target.value)} />
                          </div>
                          <div className="mb-2">
                            <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Value</label>
                            <input type="text" className="form-control" placeholder="Value" value={extraDetails?.measurableImpact?.reductionInBounceRate || ''} maxLength={VAL.UIUX.impValue} onChange={(e) => updateImpact('reductionInBounceRate', e.target.value)} />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-4 mb-3">
                        <div className="border p-3 rounded h-100">
                          <div className="mb-2">
                            <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Label</label>
                            <input type="text" className="form-control" placeholder="Label" value={extraDetails?.measurableImpact?.fasterCheckoutSpeedLabel || ''} maxLength={VAL.UIUX.impLabel} onChange={(e) => updateImpact('fasterCheckoutSpeedLabel', e.target.value)} />
                          </div>
                          <div className="mb-2">
                            <label className="form-label mb-1" style={{ fontSize: '0.85rem' }}>Value</label>
                            <input type="text" className="form-control" placeholder="Value" value={extraDetails?.measurableImpact?.fasterCheckoutSpeed || ''} maxLength={VAL.UIUX.impValue} onChange={(e) => updateImpact('fasterCheckoutSpeed', e.target.value)} />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        )}

        {showUiUxFields && (
          <div className="row mb-3">
            <div className="col-sm-12">
              <label className="form-label font-weight-bold">Quote</label>
              <textarea className="form-control" placeholder="Enter quote" rows="5" value={extraDetails?.quote || ''} onChange={(e) => updateField('quote', e.target.value)} />
            </div>
          </div>
        )}
      </div>

      {cropImageSrc && (
        <ImageCropperModal
          imageSrc={cropImageSrc}
          onCancel={() => { setCropImageSrc(null); setCropIndex(null); }}
          onCropComplete={handleCropComplete}
        />
      )}
    </div>
  );
};

export default ExtraDetails;
